const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Moment } from './Moment';
import { TokenUser } from './TokenUser';
import * as utils_topshot from "./utils_topshot"

export type sortOrderTypes = 'ListedDate_DESC' | 'ListedPrice_ASC' | 'Serial_ASC' | 'Discount_DESC' | 'Movement_DESC' | 'Movement_ASC'

export class MomentMPListing extends Moment {
  public listedPrice: number = null
  public discount: number = null
  public numOwned: number = null        // if user is logged in and MomentMPListing is an edition 
  public listedDate: Date = null
  public isLowestAsk: boolean = null
  public momentCount: number = null    // only for MomentMPListing's that are editions

  // May 18, 2024
  public flowtyListingResourceID: number  = null    // used only if it's a flowty listing

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)

    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

  public getBuyURL(): string {
    // May 23, 2024
    const flowtySuffix: string = this.flowtyListingResourceID ? `&flowty=${this.flowtyListingResourceID}` : ''

    // Jan 22, 2024
    return `https://livetoken.co/goto/moment/${this.momentID}?type=3&value=${this.listedPrice}${flowtySuffix}`
    // return this.getTopShotLink(true)
  }

  public getBuyButtonVariant(user: TokenUser): string {
    if (this.momentGUID) return 'success'
    if (user && user._temp.account && user._temp.account.flowAddress === '1c5df82849b33941') return 'primary'
    return 'success'
  }

  public getClassNameBasedOnPrice(): string {
    if (this.isLowestAsk) return 'lowestAsk'
    return 'regularAsk'
  }

  public getDiscountString(): string {
    if (this.discount === 0) return ''
    if (this.discount > 0) return `- ${Math.round(this.discount * 100)}%`
    if (this.discount < 0) return `+ ${-Math.round(this.discount * 100)}%`
  }

  public getDiscountClass(): string {
    if (this.discount === 0) return ''
    if (this.discount > 0) return 'positive'
    if (this.discount < 0) return 'negative'
  }

  public getClassNameBasedOnNumOwned(): string {
    if (this.numOwned > 0) return 'positive'
    return 'negative'
  }

}

(async () => {
})();
